/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Modal, Tabs, Select, message, notification, Checkbox, Row, Col, Form, Input, Spin, Radio, Space, Popconfirm } from 'antd';
import sources from "../../common/sources";
import fetchSourceMarkets from "../../common/helpers/fetch-source-markets";
import fetchUniswapPairs from "../../common/helpers/fetch-uniswapv2-pairs";
import { CloseOutlined, PlusCircleOutlined, WarningOutlined } from '@ant-design/icons';
import fetchUniswapPair from "../../common/helpers/fetch-uniswapv2-pair";
import dex from "../../common/dex";
import CodeEditor from '@uiw/react-textarea-code-editor';
import createScript from "../../common/helpers/create-script";
import updateScript from "../../common/helpers/update-script";
import deleteScript from "../../common/helpers/delete-script";
import fetchScript from "../../common/helpers/fetch-script";
import { useAppContext, APP_ACTIONS, userId } from "../../../context/appContext";
import calculateConversion from "../../common/helpers/calculate-conversion";
import fetchAv from "../../common/helpers/fetch-av-exchanges";
import exchanges from "../../common/exchanges";
const { TextArea } = Input;

const SelectSource = ({ selectedBot, displaySelectSource, setDisplaySelectSource, onChangeSource, orderItem, savedScripts }) => {
    const {
        state: { customMarkets, exchangeMarkets },
        dispatch
    } = useAppContext();


    const [source, setSource] = useState();
    const [sourceSymbol, setSourceSymbol] = useState();
    const [markets, setMarkets] = useState([])
    const [isSandbox, setIsSandbox] = useState(selectedBot?.host?.is_sandbox);
    const [customUrl, setCustomUrl] = useState({ custom_api_url: null, custom_websocket_url: null });
    const [isLoading, setIsLoading] = useState(false);
    const [customUniswapPair, setCustomUniswapPair] = useState();

    const [displayAddToken, setDisplayAddToken] = useState();
    const [addToken, setAddToken] = useState();
    const [uniswapPairs, setUniswapPairs] = useState(JSON.parse(localStorage.getItem(`uniswap_token_list`)) || []);
    const [customScripts, setCustomScripts] = useState([]);
    const [scriptName, setScriptName] = useState();
    const [scriptLibraries, setScriptLibraries] = useState([]);
    const [selectedCustomScript, setSelectedCustomScript] = useState();
    const [selectedNetwork, setSelectedNetwork] = useState('mainnet');
    const [displayCustomScript, setDisplayCustomScript] = useState(false);
    const [displayCustomMarket, setDisplayCustomMarket] = useState();
    const [displayWarning, setDisplayWarning] = useState();
    const [customMarketSettingApplied, setCustomMarketSettingApplied] = useState(false);
    const [customMarketConfig, setCustomMarketConfig] = useState();
    const defaultCode = `async function execute () {\n //Write your logic here \n \n\n return; // return a value that represents source price \n}  \n\nmodule.exports = execute(); // Do not change this line`
    const [code, setCode] = useState(defaultCode);
    const [conversionMarket, setConversionMarket] = useState();
    const [selectedExchange, setSelectedExchange] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [conversionObj, setConversionObj] = useState({})
    const [avaliableExhanges, setAvailableExchanges] = useState()
    const [preventOk, setPreventOk] = useState(false);
    const onClickOk = async () => {
        if (!selectedNetwork) {
            message.error({ content: "Please select network" });
            return;
        }
        if (customUniswapPair?.token1 || customUniswapPair?.token2) {
            const pair = await fetchUniswapPair(customUniswapPair.token1, customUniswapPair.token2, selectedNetwork)
            if (pair.error) {
                message.error({ content: pair.error })
                return;
            }
        }

        let scriptId;
        if (displayCustomScript && selectedCustomScript === 'new') {
            try {
                message.loading({ content: scriptLibraries.length > 0 ? 'Installing the libraries...' : 'Waiting...', key: 'scriptInstall', duration: 0 });
                const script = await createScript({ script_name: scriptName, libraries: scriptLibraries, script: code })
                message.destroy('scriptInstall');
                if (script.error) {
                    message.error({ content: script.error })
                    return;
                }
                scriptId = script.createdScript.id
                message.success({ content: "Changes Saved" });
            } catch (err) {
                message.error({ content: err.message })
                return;
            }
        } else if (selectedCustomScript && selectedCustomScript !== 'new') {
            message.loading({ content: scriptLibraries.length > 0 ? 'Updating the script...' : 'Waiting...', key: 'scriptInstall', duration: 0 });
            scriptId = selectedCustomScript
            const script = await updateScript({ id: scriptId, script_name: scriptName, libraries: scriptLibraries, script: code })
            message.destroy('scriptInstall');
            if (script.error) {
                message.error({ content: script.error })
                return;
            }
        }
        setDisplaySelectSource(false);
        onChangeSource(source, sourceSymbol, customUniswapPair, selectedNetwork, isSandbox, customUrl, scriptId, customMarketConfig, conversionMarket);
    }
    const handleChange = (value) => {
        setSelectedExchange(value);

        message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });

        fetchAv({ exchangeId: value, pair: conversionObj?.customConfig?.symbol, isSandbox, custom_urls: customUrl }).then((a => {
            if (!a.error) { 
                calculateConversion({ exchangeId: source, selectedSymbol: sourceSymbol, marketFocus: orderItem?.symbol, userId,
                    custom_urls: customUrl,
                    isSandbox, overridePrice: {
                    first_asset: conversionObj?.customConfig?.symbol.split('/')[0].toLowerCase(),
                    second_asset:  conversionObj?.customConfig?.symbol.split('/')[1].toLowerCase(),
                    price: a.price,
                    symbol: conversionObj?.customConfig?.symbol,
                    id: 9999999
                } }).then(res => {
                    if (res.error) {
                        setErrorMessage(res.error);
                        setDisplayWarning(true);
                    } else {
                        setConversionObj(res)
                        setDisplayCustomMarket(true);
                        setErrorMessage('')
                    }
                    message.destroy('conversion');
                })
            } else {
                message.destroy('conversion');
                message.error(a.error);
            }
        }))
    };
    useEffect(() => {
        if (!orderItem?.symbol) { setPreventOk(true); }

        if (Array.isArray(savedScripts)) {
            setCustomScripts([...savedScripts])

            if (orderItem.scriptId) {
                const foundScript = savedScripts.find(script => script.id === orderItem.scriptId);
                if (foundScript) {
                    setDisplayCustomScript(true);
                    setSource("Custom Script");
                    setSelectedCustomScript(orderItem.scriptId);
                    setScriptLibraries(foundScript.libraries);
                    setScriptName(foundScript.script_name);
                    setCode(foundScript.script);
                }
            }
            else {
                setIsLoading(true)
                if (orderItem?.source) {

                    if(!orderItem?.customUrl){
                        const selectedMarket = exchangeMarkets.find(x => x.id == `${orderItem?.source}${orderItem?.isSandbox ? 'true' : 'false'}`);
                        if(selectedMarket && selectedMarket.date.getTime() + 1000 * 60 * 120 > new Date().getTime())
                        {
                            setMarkets(selectedMarket.markets);
                            setIsLoading(false);
                        }
                        else {
                            fetchSourceMarkets(orderItem?.source, orderItem?.isSandbox, orderItem?.customUrl).then(res => {
                                if (Array.isArray(res)) {
                                    setMarkets(res);
                                    dispatch({ 
                                        type: APP_ACTIONS.SET_MARKETS,
                                        payload:{ id: `${orderItem?.source}${orderItem?.isSandbox ? 'true' : 'false'}`, markets: res, date: new Date() }
                                    })
                                }
                                setIsLoading(false);
                            }).catch(err => { setIsLoading(false) })
                        
                        }
                    }
                    else
                    {
                        fetchSourceMarkets(orderItem?.source, orderItem?.isSandbox, orderItem?.customUrl).then(res => {
                            if (Array.isArray(res)) {
                                setMarkets(res);
                            }
                            setIsLoading(false);
                        }).catch(err => { setIsLoading(false) })
                    }
                }
                setSource(orderItem?.source);
                setSourceSymbol(orderItem?.source_symbol);
                setIsSandbox(orderItem?.isSandbox == null ? selectedBot?.host?.is_sandbox : orderItem?.isSandbox)
                setCustomUrl(orderItem?.customUrl)
                if (orderItem?.customMarketConfig) {
                    setCustomMarketSettingApplied(true);
                    setCustomMarketConfig(orderItem?.customMarketConfig)
                }

                if (orderItem?.conversionMarket) {
                    setCustomMarketSettingApplied(true);
                    setConversionMarket(orderItem?.conversionMarket)
                }
            }
        }
    }, [])
    useEffect(() => {
        if (!isSandbox) {
            setCustomUrl({
                custom_api_url: "https://api.hollaex.com", custom_websocket_url: "wss://api.hollaex.com/stream"
            })
        } else {
            setCustomUrl({
                custom_api_url: "https://api.sandbox.hollaex.com", custom_websocket_url: "wss://api.sandbox.hollaex.com/stream"
            })
        }

        setIsLoading(true)
        if (source) {
            fetchSourceMarkets(source, isSandbox, customUrl).then(res => {
                if (Array.isArray(res)) {
                    setMarkets(res);
                }
                setIsLoading(false);
            }).catch(err => { setIsLoading(false) })
        }
    }, [isSandbox])
    const goBack = () => {
        setDisplaySelectSource(false);
    }

    const handleConnectToDEX = () => {
        setMarkets([]);
        setIsLoading(true);
        fetchUniswapPairs().then(res => {
            setIsLoading(false);
            if (Array.isArray(res)) {
                setMarkets(res);
            }
        }).catch(err => { setIsLoading(false); console.log({ err }) })
    }

    const handleDeleteScript = async (id) => {
        const deletedScript = await deleteScript(id);

        if (deletedScript.error) {
            message.error(deletedScript.error);
            return;
        }
        const scripts = await fetchScript();
        if (Array.isArray(scripts)) {
            setCustomScripts([...scripts])
        }

        setScriptLibraries([]);
        setSelectedCustomScript('new');
        setScriptName();
        setCode(defaultCode)
        message.success('Script removed');

    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displaySelectSource} footer={null} onCancel={() => { setDisplaySelectSource(false); }}>

            <>

                {displayWarning && <Modal
                    maskClosable={false}
                    closeIcon={<CloseOutlined style={{ color: "white" }} />}
                    bodyStyle={{
                        backgroundColor: 'black',
                        border: "1px solid grey"
                    }}
                    // style={{ marginTop: 40 }}
                    visible={displayWarning} footer={null} onCancel={() => { setDisplayWarning(false); }}>

                    <div style={{ fontWeight: "600", color: "white" }}>
                        <WarningOutlined /> Different Market Warning
                    </div>
                    <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                        {errorMessage ? errorMessage : `You chose not to apply the conversion. Keep in my mind that this source price does not belong to the strategy's market.`}
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                        <Button onClick={() => {
                            setErrorMessage('');
                            setDisplayWarning(false);
                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>

                    </div>

                </Modal>
                }
                {displayCustomMarket && <Modal
                    maskClosable={false}
                    closeIcon={<CloseOutlined style={{ color: "white" }} />}
                    bodyStyle={{
                        backgroundColor: 'black',
                        border: "1px solid grey"
                    }}
                    // style={{ marginTop: 40 }}
                    visible={displayCustomMarket} footer={null} onCancel={() => { setDisplayCustomMarket(false); }}>

                    <div style={{ fontWeight: "600", color: "white" }}>
                        {errorMessage ? <span><WarningOutlined /> Different Market Warning </span> : 'Market Conversion'}


                    </div>
                    <div style={{ color: "white", marginTop: 20, marginBottom: 40 }}>
                        {errorMessage ? errorMessage :
                            <div>
                                <div>Conversion found using the market <span style={{ fontWeight: 'bold' }}>{conversionObj?.customConfig?.symbol}</span> from the config</div>
                                <div>{conversionObj?.customConfig?.symbol} price: <span style={{ fontWeight: 'bold' }}>{conversionObj?.customConfig?.price}</span></div>
                                <div>Converted price : {!conversionObj?.newPrice?.toString()?.startsWith("0") ? <span style={{ fontWeight: 'bold' }}>{conversionObj?.newPrice?.toFixed(4)}</span> : <span style={{ fontWeight: 'bold' }}>{conversionObj?.newPrice}</span>}</div>

                                <div style={{ fontWeight: 'bold', marginTop: 15, marginBottom: 10 }}>If you wish to proceed, this conversion will be applied. Alternatively you can also select the {conversionObj?.customConfig?.symbol} price from below exchanges <span style={{ fontWeight: 'bold', color: 'red', textDecoration: 'underline' }}>which will override your pirce fom the config.</span>  </div>
                                
                                <Select
                                    showSearch
                                    style={{ width: 300 }}
                                    placeholder="Search and select an exchange"
                                    optionFilterProp="children"
                                    onChange={handleChange}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {exchanges.filter(exchange => exchange.value != 'Custom Script').map((exchange) => (
                                        <Option key={exchange.value} value={exchange.value}>
                                            {exchange.label}
                                        </Option>
                                    ))}
                                </Select>

                                {selectedExchange === 'hollaex' && <>
                                {customUrl.custom_api_url != null && <div style={{ color: "white", margin: "30px 0" }}>
                                    <label>Custom API Url (Optional)</label>
                                    <Input value={customUrl.custom_api_url} onChange={(e) => { setCustomUrl({ ...customUrl, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                </div>}
                                {customUrl.custom_websocket_url != null && <div style={{ color: "white", margin: "30px 0" }}>
                                    <label>Custom Websocket Url (Optional)</label>
                                    <Input value={customUrl.custom_websocket_url} onChange={(e) => { setCustomUrl({ ...customUrl, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                </div>}

                                <div>
                                <Button onClick={() => {
                                    handleChange(selectedExchange);

                                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, }} type="default">Fetch the price with the custom urls </Button>
                                </div>
                            </>}

                            
                            </div>
                        }
                        {/* You selected a different market than the strategy's market. Would you like to apply your custom market config to this market? This will override price you will get from the selected exchange  (If you don't have a custom config for the selected market, Please create one on 'MY MARKET CONFIG' page) */}
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                        <Button onClick={() => {
                            setConversionMarket();
                            setErrorMessage('');
                            setDisplayWarning(true);
                            setDisplayCustomMarket(false);
                            setCustomMarketSettingApplied(false);

                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">CANCEL</Button>
                        <Button onClick={() => {

                            // let found = customMarkets?.find(market => market.symbol === sourceSymbol)
                            // if (found) {
                            //     setCustomMarketSettingApplied(true);
                            //     setCustomMarketConfig(found);
                            // } else {
                            //     message.error('Could not find a config for the selected market')
                            //     setCustomMarketSettingApplied(false);
                            //     setCustomMarketConfig(null);
                            // }
                            setConversionMarket(conversionObj?.customConfig);
                            setCustomMarketSettingApplied(true);
                            setErrorMessage('');
                            setDisplayCustomMarket(false);

                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">PROCEED</Button>
                    </div>

                </Modal>
                }
                <div style={{ fontWeight: "600", color: "white" }}>Platform source reference price</div>
                <div style={{ color: "grey", marginTop: 10 }}>Set the reference price that the bot will source prices from. Prices can be sourced from various platforms or custom APIs.</div>
                <div style={{ color: "white", marginTop: 30 }}>
                    <label>Platform</label>
                    <Select
                        showSearch
                        style={{ width: "100%", marginTop: 10 }}
                        placeholder="Select platform"
                        value={source}
                        onChange={(value) => {
                            setSelectedCustomScript();
                            setCustomUniswapPair();
                            setSourceSymbol();
                            setDisplayCustomScript(false);
                            setSource(value);
                            setCustomMarketSettingApplied(false);
                            setCustomMarketConfig(null);
                            setConversionMarket();
                            if (value === 'uniswap') {
                                handleConnectToDEX();
                            }
                            else if (value === 'Custom Script') {
                                setMarkets([]);
                                setDisplayCustomScript(true);
                            }
                            else {
                                if (value !== 'custom') {
                                    setMarkets([]);
                                    setIsLoading(true)

                                    const selectedMarket = exchangeMarkets.find(x => x.id == `${value}${isSandbox ? 'true' : 'false'}`);
                                    if(selectedMarket && selectedMarket.date.getTime() + 1000 * 60 * 120 > new Date().getTime())
                                    {
                                        setMarkets(selectedMarket.markets);
                                        setIsLoading(false);
                                    }
                                    else {
                                        fetchSourceMarkets(value, isSandbox, customUrl).then(res => {
                                            if (Array.isArray(res)) {
                                                setMarkets(res);
                                                dispatch({ 
                                                    type: APP_ACTIONS.SET_MARKETS,
                                                    payload:{ id: `${value}${isSandbox ? 'true' : 'false'}`, markets: res, date: new Date() }
                                                })
                                            }
                                         
                                            setIsLoading(false);
                                        }).catch(err => { setIsLoading(false) })

                                    }
                                }
                            }
                        }}
                    >
                        {sources.map(source => <Option value={source.value}>{source.label}</Option>)}
                    </Select>
                </div>
                {source === 'custom' ?
                    <div style={{ color: "white", marginBottom: 50, marginTop: 30 }}>
                        <label>Input custom price</label>
                        <TextArea onChange={(e) => { setSourceSymbol(e.target.value) }} style={{ marginTop: 10 }} placeholder="Input custom value to make your own price" rows={1} />
                    </div>
                    :
                    displayCustomScript ?
                        <div style={{ color: "white", marginBottom: 50, marginTop: 15 }}>
                            <label>Saved Scripts</label>
                            <Select
                                showSearch
                                value={customScripts?.find(script => script.id === selectedCustomScript)?.script_name}
                                placeholder="Select a script"
                                style={{ color: "black", width: "100%" }}
                                notFoundContent={'Not Found'}
                                onChange={(value) => {
                                    setScriptLibraries([]);
                                    setScriptName();
                                    setCode(defaultCode)

                                    const script = customScripts?.find(script => script.id === value)
                                    if (script) {
                                        if (Array.isArray(script.libraries)) {
                                            setScriptLibraries([...script.libraries]);
                                        } else {
                                            setScriptLibraries([]);
                                        }
                                        setScriptName(script.script_name);
                                        setCode(script.script)
                                    }

                                    setSelectedCustomScript(value)
                                }}
                            >
                                <Option value={'new'}>New</Option>
                                {customScripts.map(script => <Option value={script.id}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <div>{script.script_name}</div>

                                        <Popconfirm

                                            title="Are you sure to delete this script?"
                                            onConfirm={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleDeleteScript(script.id);

                                            }}
                                            onCancel={() => { }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();

                                                }}
                                                danger size="small">
                                                Delete
                                            </Button>
                                        </Popconfirm>

                                    </div>
                                </Option>)}

                            </Select>
                            <>
                                <div style={{ marginBottom: 20, marginTop: 20 }}>
                                    <label>Script Name</label>
                                    <TextArea value={scriptName} onChange={(e) => { setScriptName(e.target.value) }} style={{ marginTop: 10 }} placeholder="Enter Script Name" rows={1} />
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label>Libraries to install</label>
                                    <Select
                                        mode="tags"
                                        value={scriptLibraries}
                                        style={{
                                            width: '100%',
                                            marginTop: 10
                                        }}
                                        placeholder="Add libraries that your script requires if any"
                                        onChange={(value) => { setScriptLibraries(value); }}
                                    >
                                        {["lodash@4.17.21"].map(lib => <Option key={lib}>{lib}</Option>)}
                                    </Select>
                                    <div style={{ fontStyle: "italic", fontSize: 13, marginTop: 2 }}>You can also define version when adding a library, e.g: lodash@4.17.21 </div>
                                    <div style={{ fontStyle: "italic", fontSize: 13, marginTop: 10 }}>You can access the libraries you installed by the following way in the script, e.g. const lodash = installedLibraries['lodash'];</div>
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label>Script Code</label>
                                    <CodeEditor
                                        value={code}
                                        language="js"
                                        placeholder="Please enter JS code."
                                        onChange={(evn) => setCode(evn.target.value)}
                                        padding={15}
                                        style={{
                                            minHeight: 300,
                                            fontSize: 12,
                                            border: "1px solid grey",
                                            backgroundColor: "#0D1117",
                                            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                                        }}
                                    />
                                </div>
                            </>

                        </div>
                        :
                        <div style={{ color: "white", marginBottom: 50, marginTop: 30 }}>
                            <label>Price source symbol</label>
                            {/* <Input placeholder="Enter source symbol" onChange={(e) => { setSourceSymbol(e.target.value) }} /> */}

                            <div>
                                <Select
                                    showSearch
                                    placeholder="Enter source symbol"
                                    notFoundContent={isLoading ? <Spin size="small" /> : null}
                                    style={{ color: "black", width: "100%" }}
                                    onChange={(value) => {
                                        if (!orderItem?.symbol) { message.error("Please select strategy market focus first."); setPreventOk(true); return; }

                                        setCustomUniswapPair();
                                        setCustomMarketSettingApplied(false);
                                        setCustomMarketConfig(null);
                                        setConversionMarket();
                                        if (orderItem?.symbol && orderItem?.symbol !== value && source !== 'uniswap') {

                                            message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });
                                            calculateConversion({ exchangeId: source, selectedSymbol: value, marketFocus: orderItem?.symbol, userId, isSandbox }).then(res => {
                                                if (res.error) {
                                                    setErrorMessage(res.error);
                                                    setDisplayWarning(true);
                                                } else {
                                                    setConversionObj(res)
                                                    setDisplayCustomMarket(true);
                                                    setErrorMessage('')
                                                }
                                                message.destroy('conversion');
                                            })
                                        }

                                        setSourceSymbol(value);

                                    }}
                                    value={sourceSymbol}
                                >
                                    {source === 'uniswap' && <Option value={'uniswap_custom_symbol'}>Add Custom Pair</Option>}
                                    {(markets || []).map(market => <Option value={market.symbol}>{market.symbol}</Option>)}

                                </Select>

                                {(orderItem?.symbol && sourceSymbol && orderItem?.symbol !== sourceSymbol && !dex.includes(source)) &&
                                    <Checkbox checked={customMarketSettingApplied} style={{ color: "white", marginTop: 10 }} onChange={(e) => {
                                        if (e.target.checked) {
                                            message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });
                                            calculateConversion({ exchangeId: source, selectedSymbol: sourceSymbol, marketFocus: orderItem?.symbol, userId, isSandbox }).then(res => {
                                                if (res.error) {
                                                    setErrorMessage(res.error);
                                                    setDisplayWarning(true);
                                                } else {
                                                    setConversionObj(res)
                                                    setDisplayCustomMarket(true);
                                                    setErrorMessage('')
                                                }
                                                message.destroy('conversion');
                                            })

                                        } else {
                                            setConversionMarket();
                                            setCustomMarketSettingApplied(e.target.checked);
                                        }

                                    }}>Apply custom market config </Checkbox>
                                }
                                {sourceSymbol === 'uniswap_custom_symbol' && <>
                                    <div style={{ display: "flex", flexDirection: "row", gap: 10, marginTop: 15 }}>
                                        <Select
                                            showSearch
                                            value={customUniswapPair?.symbol1 || null}
                                            placeholder="Select First Token"
                                            style={{ color: "black", width: "100%" }}
                                            notFoundContent={'Not Found'}
                                            onChange={(value) => { setCustomUniswapPair({ ...customUniswapPair, token1: JSON.parse(value).token_address, symbol1: JSON.parse(value).symbol }) }}
                                        >
                                            {uniswapPairs.map(token => <Option value={JSON.stringify(token)}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div>{token.symbol}</div>
                                                    <Button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            const tokenList = localStorage.getItem(`${source}_token_list`);
                                                            let parsed = JSON.parse(tokenList);
                                                            parsed = parsed.filter(x => x.token_address !== token.token_address)
                                                            localStorage.setItem(`${source}_token_list`, JSON.stringify(parsed));
                                                            setUniswapPairs(parsed);
                                                            setCustomUniswapPair({ ...customUniswapPair, token1: null, symbol1: null })
                                                        }}
                                                        danger size="small">
                                                        Delete
                                                    </Button>
                                                </div>
                                            </Option>)}

                                        </Select>

                                        <Select
                                            showSearch
                                            value={customUniswapPair?.symbol2 || null}
                                            placeholder="Select Second Token"
                                            style={{ color: "black", width: "100%" }}
                                            notFoundContent={'Not Found'}
                                            onChange={(value) => { setCustomUniswapPair({ ...customUniswapPair, token2: JSON.parse(value).token_address, symbol2: JSON.parse(value).symbol }) }}
                                        >
                                            {uniswapPairs.map(token => <Option value={JSON.stringify(token)}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div>{token.symbol}</div>
                                                    <Button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            const tokenList = localStorage.getItem(`${source}_token_list`);
                                                            let parsed = JSON.parse(tokenList);
                                                            parsed = parsed.filter(x => x.token_address !== token.token_address)
                                                            localStorage.setItem(`${source}_token_list`, JSON.stringify(parsed));
                                                            setUniswapPairs(parsed);
                                                            setCustomUniswapPair({ ...customUniswapPair, token2: null, symbol2: null })
                                                        }}
                                                        danger size="small">
                                                        Delete
                                                    </Button>
                                                </div>
                                            </Option>)}

                                        </Select>

                                        <Button
                                            style={{ backgroundColor: "#161616", color: "white", }}
                                            onClick={() => { setDisplayAddToken(true) }}
                                            type="primary" icon={<PlusCircleOutlined />}>
                                            Add Token
                                        </Button>

                                    </div>

                                    <Modal
                                        maskClosable={false}
                                        closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                        bodyStyle={{
                                            backgroundColor: 'black',
                                            border: "1px solid grey"
                                        }}
                                        visible={displayAddToken} footer={null} onCancel={() => { setDisplayAddToken(false); }}>
                                        <div style={{ fontWeight: "600", color: "white" }}>Add Token</div>
                                        <div>
                                            <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>Token Symbol(e.g: xht)</label>
                                                <Input value={addToken?.symbol} onChange={(e) => { setAddToken({ ...addToken, symbol: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input token symbol" />
                                            </div>
                                            <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>Token Address</label>
                                                <Input value={addToken?.token_address} onChange={(e) => { setAddToken({ ...addToken, token_address: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input first token address" />
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                                            <Button onClick={() => { setDisplayAddToken(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                                            <Button onClick={() => {
                                                const tokenList = localStorage.getItem(`${source}_token_list`);
                                                if (tokenList) {
                                                    const parsed = JSON.parse(tokenList);
                                                    if (!addToken?.symbol || !addToken?.token_address) {
                                                        message.error({ content: 'Please fill the input boxes' })
                                                        return;
                                                    }
                                                    if (parsed.find(x => x.token_address === addToken?.token_address) || parsed.find(x => x.symbol === addToken?.symbol?.toLowerCase())) {
                                                        message.error({ content: 'Token already in the list' })
                                                        return;
                                                    }
                                                    if (addToken?.symbol?.indexOf(' ') >= 0) {
                                                        message.error({ content: 'Invalid Symbol' })
                                                        return;
                                                    }
                                                    parsed.push(addToken);
                                                    localStorage.setItem(`${source}_token_list`, JSON.stringify(parsed));
                                                    setUniswapPairs(parsed);
                                                } else {
                                                    localStorage.setItem(`${source}_token_list`, JSON.stringify([addToken]));
                                                    setUniswapPairs([addToken]);
                                                }
                                                setAddToken();
                                                setDisplayAddToken(false);
                                            }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">COMPLETE</Button>
                                        </div>

                                    </Modal>

                                </>}

                                {source === 'uniswap' &&
                                    <div style={{ display: "flex", flexDirection: "column", marginTop: 15 }}>
                                        <span>Network Option</span>
                                        <Radio.Group style={{ marginTop: 5 }} onChange={((e) => {
                                            setSelectedNetwork(e.target.value)
                                        })}
                                            value={selectedNetwork}
                                        >
                                            <Space direction="vertical">
                                                <Radio style={{ color: "white" }} value={'mainnet'}>Mainnet</Radio>
                                                <Radio style={{ color: "white" }} value={'ropsten'}>Ropsten</Radio>
                                                <Radio style={{ color: "white" }} value={'rinkeby'}>Rinkeby</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                }
                            </div>
                            {source === 'hollaex' && <>
                                {customUrl.custom_api_url != null && <div style={{ color: "white", margin: "30px 0" }}>
                                    <label>Custom API Url (Optional)</label>
                                    <Input value={customUrl.custom_api_url} onChange={(e) => { setCustomUrl({ ...customUrl, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                </div>}
                                {customUrl.custom_websocket_url != null && <div style={{ color: "white", margin: "30px 0" }}>
                                    <label>Custom Websocket Url (Optional)</label>
                                    <Input value={customUrl.custom_websocket_url} onChange={(e) => { setCustomUrl({ ...customUrl, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                </div>}
                            </>}


                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", marginTop: 15 }}>
                                {!dex.includes(source) && <div style={{ color: "white", }}>
                                    <Checkbox checked={isSandbox} style={{ color: "white" }} onChange={(e) => {
                                        setIsSandbox(e.target.checked);
                                    }}>Sandbox mode </Checkbox>
                                </div>}


                                {source == 'hollaex' && <div style={{}}><Button onClick={() => {
                                    setIsLoading(true);
                                    fetchSourceMarkets(source, isSandbox, customUrl).then(res => {
                                        if (res.error) {
                                            message.error(res.error);
                                            return;
                                        }
                                        if (Array.isArray(res)) {
                                            setMarkets(res);
                                            message.success('Markets fetched.')
                                        }
                                        setIsLoading(false);
                                    }).catch(err => { setIsLoading(false) })
                                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, }} >Refresh Markets</Button></div>}
                            </div>



                        </div>
                }


            </>


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => {
                    if (!preventOk) { onClickOk() } else {
                        message.error("Please select strategy market focus first.");
                    }
                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal>
    );
};

export default SelectSource;